import api from "./core/api"


const BASE_PATH = '/accounts';
export const ENDPOINT = process.env.API_URL
const HEADERS_BASE = {
  "Content-Type": "application/json",
  "Accept": "application/json",
}

async function updateUser(data) {
  return await api.put(BASE_PATH + '/update-user', data);
}

async function getOrders(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }
    return await api.get(BASE_PATH + '/your-orders', {
      headers: headers,
    });
}

async function getDetails(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }

  return await api.get(BASE_PATH + '/your-information', {
    headers: headers,
  });
}

async function updateDetails(data, token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }
  return await api.put(BASE_PATH + '/update-user', data, config);
}

async function updatePassword(data, token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }

  return await api.put(BASE_PATH + '/update-password', data, config);
}

async function updateAddresses(data, token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }
  return await api.put(BASE_PATH + '/update-information', data, config);
}

async function createUserReferralCode(token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }
  return await api.post(BASE_PATH + '/create-referral', {}, config);
}

async function getUserReferralCode(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }
  return await api.get(BASE_PATH + '/referral', {
    headers: headers,
  });
}

async function getReferralCredit(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }
  return await api.get(BASE_PATH + '/referral-credit', {
    headers: headers,
  });
}

async function getUserReferrals(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }
  return await api.get(BASE_PATH + '/your-referrals', {
    headers: headers,
  });
}

async function checkExistingAccount(token) {
  const headers = {
    ...HEADERS_BASE,
    "token": token
  }
  return await api.get(BASE_PATH + '/is-customer', {
    headers: headers,
  });
}

async function createReferralDiscountCode(token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }
  return await api.get(BASE_PATH + '/advocate-code', config);
}
async function sendReferralEmail(data, token) {
  const config = {
    headers: {
      ...HEADERS_BASE,
      "token": token
    }
  }
  return await api.post(BASE_PATH + '/send-referral', data, config);
}

const account = {
    updateUser: updateUser,
    getOrders: getOrders,
    getDetails: getDetails,
    updateDetails: updateDetails,
    updateAddresses: updateAddresses,
    createUserReferralCode: createUserReferralCode,
    getUserReferralCode: getUserReferralCode,
    getReferralCredit: getReferralCredit,
    getUserReferrals: getUserReferrals,
    createReferralDiscountCode: createReferralDiscountCode,
    updatePassword: updatePassword,
    sendReferralEmail: sendReferralEmail,
    checkExistingAccount: checkExistingAccount
};

export default account;
